<main id="main-content" class="main-content">
  <h2 class="form-header">Regional Approval & Certification</h2>

  <mat-card>
    <h2 class="forest-title">Select Regional Line Officers</h2>
    <div class="border-div"></div>
    <div class="text-div">
      The Regional Funding Recommendations report needs to be signed and certified by the regional line officer(s). Please identify the regional line officer contact(s) for each forest to ensure the required signatures are obtained promptly and funding is authorized.
    </div>
    @for (forest of forests; track forest; let i = $index) {
      <div>
        <form [formGroup]="forest.form">
          <div class="title">Region {{ forest.region }}</div>
          <mat-radio-group required class="radio-buttons" formControlName="new_or_existing" (input)="update()">
            <mat-radio-button [value]="'existing'" color="primary">Search for an existing regional line officer
            (preferred)</mat-radio-button>
            <br>
              @if (forest.form.value.new_or_existing == 'existing') {
                <div class="side-line">
                  <div class="table-container">
                    <table mat-table [dataSource]="forest.users" class="center" matSort matSortDisableClear
                      aria-hidden="false">
                      <form [formGroup]="forest.selectUserForm">
                        <mat-radio-group formControlName="user">
                          <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                            <td class="user-cell" mat-cell *matCellDef="let user"
                              [style.background-color]="user.isSelected ? '#FFF5E1' : 'white'">
                              <div style="display:flex">
                                <mat-radio-button [value]="user" color="primary" class="radio-button"
                                (change)="radioChange($event, forest)"></mat-radio-button>
                                <div class="user-cell-name">
                                  <div class="user-icon vertical-center">
                                    <p>{{user.first_name[0]}}</p>
                                  </div>
                                  <p class="user-name-2">{{user.first_name + " " + user.last_name}}
                                  </p>
                                </div>
                              </div>
                            </td>
                          </ng-container>
                        </mat-radio-group>
                      </form>
                      <ng-container matColumnDef="position">
                        <th mat-header-cell *matHeaderCellDef>Position</th>
                        <td mat-cell *matCellDef="let user">
                          @if (user.baer_roles.length != 0) {
                            <mat-chip class="chip"
                            >{{user.baer_roles[0].baer_role.text}}</mat-chip>
                          } @else {
                            --
                          }
                          @if (user.baer_roles.length > 1) {
                            <mat-chip class="chip" style="margin-left: 5px;"
                              [matTooltip]='user.tooltip' matTooltipClass="tooltipClass">
                              +{{user.baer_roles.length - 1}}
                            </mat-chip>
                          }
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="forest">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 280px;">Forest
                        name</th>
                        <td mat-cell *matCellDef="let user">
                          {{ user.forest_name }}
                        </td>
                      </ng-container>
                      <tr mat-header-row *matHeaderRowDef="displayedColumns sticky: true" class="header-row"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                      <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="6">
                          <div class="no-data">
                            <div class="no-data-icon">
                              <fa-icon [icon]="faUsers" class="no-data-icon"></fa-icon>
                            </div>
                            <div class="no-data-title">No team members found</div>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              }
              <mat-radio-button [value]="'new'" color="primary">Add new regional line officer</mat-radio-button>
              @if (forest.form.value.new_or_existing == 'new') {
                <div >
                  <form class="user_form side-line" [formGroup]="forest.form">
                    <mat-form-field appearance="outline">
                      <mat-label>First Name</mat-label>
                      <input matInput formControlName="first_name" required cdkFocusInitial (input)="update()">
                      <mat-error>Required Field</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>Last Name</mat-label>
                      <input matInput formControlName="last_name" required cdkFocusInitial (input)="update()">
                      <mat-error>Required Field</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>Email Address</mat-label>
                      <input matInput formControlName="email" required
                        pattern="[a-zA-Z0-9._%+\-]+&#64;[a-z0-9.\-]+\.[a-z]{2,3}$" cdkFocusInitial
                        (focusout)="checkIfUserExists(forest)" (keyup.enter)="checkIfUserExists(forest)">
                        @if (forest.form.value.email == '') {
                          <mat-error>Required Field</mat-error>
                        }
                        @if (forest.form.controls.email.errors?.pattern) {
                          <mat-error>Please enter a valid
                          email</mat-error>
                        }
                        @if (forest.form.controls.email.errors?.TeamMember) {
                          <mat-error>Team member already
                          exists</mat-error>
                        }
                      </mat-form-field>
                      <mat-form-field appearance="outline">
                        <mat-label>Phone Number</mat-label>
                        <input matInput formControlName="phone_num" cdkFocusInitial placeholder="(XXX) XXX-XXXX"
                          mask="(000) 000-0000">
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                          <mat-label>Line Officer Position</mat-label>
                          <mat-select formControlName="lo_position" required (input)="update()">
                            @for (role of filtered_roles; track role) {
                              <mat-option [value]="role">{{role.text}}</mat-option>
                            }
                          </mat-select>
                          <mat-error>Required Field</mat-error>
                        </mat-form-field>
                      </form>
                      @if (doesUserExist) {
                        <ng-container *ngTemplateOutlet="addExistingUserToROLO"></ng-container>
                      }
                      <button mat-flat-button [class]="forest.form.invalid? '':'add-user' " color="primary"
                      (click)="upsertLineOfficer(forest)" [disabled]="forest.form.invalid">Save and Select</button>
                    </div>
                  }
                </mat-radio-group>
                <div class="divide-line"></div>
                <div class="title">
                  The Regional Funding Recommendations Report for Region {{ forest.region }} will be sent to:
                </div>
                <div class="contact-container">
                  @if (forest.form.value.new_or_existing == 'new' && (forest.form.value.first_name && forest.form.value.last_name && forest.form.value.email && forest.form.value.lo_position)) {
                    <mat-card
                      class="contact-card">
                      <div>
                        <div class="user-cell-name">
                          <div class="user-icon">
                            <p>{{(forest.form.value.first_name || "?")[0]}}</p>
                          </div>
                          @if (forest.form.value.first_name || forest.form.value.last_name) {
                            <p class="user-name-basic"
                              >
                            {{forest.form.value.first_name + " " + forest.form.value.last_name}}</p>
                          }
                          @if (!forest.form.value.first_name && !forest.form.value.last_name) {
                            <p class="user-name-basic"
                            >New User</p>
                          }
                        </div>
                        <div class="user-cell-details">
                          @if (forest.form.value.lo_position) {
                            <mat-chip>{{ forest.form.value.lo_position.text
                            }}</mat-chip>
                          }
                          @if (forest.form.value.phone_num) {
                            <div class="details-number"><mat-icon>phone</mat-icon>
                            {{( forest.form.value.phone_num | phone) ||
                            "--"}}
                          </div>
                        }
                        @if (forest.form.value.email) {
                          <div class="details-email">
                            <mat-icon>email</mat-icon>{{forest.form.value.email}}
                          </div>
                        }
                        <div class="details-email"><mat-icon>location_on</mat-icon>{{ forest.form.value }}</div>
                      </div>
                    </div>
                  </mat-card>
                }
                @if (forest.selectUserForm.value.user==null && (forest.form.value.new_or_existing != 'new'
                  || !(forest.form.value.first_name && forest.form.value.last_name && forest.form.value.email && forest.form.value.lo_position))) {
                  <div
                    class="text-div">
                    <span class="gray-text">No contact selected</span>
                  </div>
                }
              </div>
              @if (forest.selectUserForm.value.user && forest.form.value.new_or_existing == 'existing') {
                <mat-card
                  class="contact-card">
                  <div>
                    <div class="user-cell-name">
                      <div class="user-icon">
                        <p>{{forest.selectUserForm.value.user.first_name[0]}}</p>
                      </div>
                      <a [routerLink]="['/user']" [queryParams]="{user_id: forest.selectUserForm.value.user?.user_id}"
                        class="user-name">{{forest.selectUserForm.value.user.first_name + " " +
                      forest.selectUserForm.value.user.last_name}}</a>
                    </div>
                    <div class="user-cell-details">
                      <mat-chip>{{
                        forest.selectUserForm.value.user.baer_roles[0].baer_role.text
                      }}</mat-chip>
                      <div class="details-number"><mat-icon>phone</mat-icon>
                      {{(forest.selectUserForm.value.user.phone_num | phone) ||
                      "--"}}
                    </div>
                    <div class="details-email"><mat-icon>email</mat-icon>{{forest.selectUserForm.value.user.email}}
                  </div>
                  <div class="details-email"><mat-icon>location_on</mat-icon>Region {{ forest.region }}</div>
                </div>
              </div>
            </mat-card>
          }
        </form>
        @if (i != 0) {
          <div class="divide-line"></div>
        }
      </div>
    }
  </mat-card>
</main>

<ng-template #addExistingUserToROLO>
  <div class="yellow-warning">
    <fa-icon [icon]="faWarning" class="faWarning" aria-label="Warning"></fa-icon>
    <div class="support-text">
      <b>The team member you are trying to add already exists in the user roster database.</b>
      <div>You can still add them as a line officer to expedite the sign-off of this report.</div>
      <div>Select <strong>Regional Line Officer</strong> or <strong>Acting Regional Line Officer</strong> from the <i>Line
    Officers Position</i> dropdown, then click on
    <strong>Save and Select</strong>.</div>
    <div><strong>Tip</strong>: You can also add this role from the Roster module under the Line Officers tab.</div>
  </div>
</div>
</ng-template>
